import React from "react";
import { BsArrowDown } from "react-icons/bs";
import { Link } from "react-router-dom";
import Image from "../../assets/images/product-img.png";
const Products = () => {
  return (
    <div className="bg-gray-100 w-full grid grid-cols-1 md:grid-cols-2 md:px-24 px-12 py-20">
      {/* Description */}
      <div className="w-full md:pr-10 pr-0" style={{}}>
        <div className="flex items-center">
          <h1
            style={{}}
            className=" font-light text-4xl text-pink-600 md:mr-6 mr-0"
          >
            Products
          </h1>
        </div>
        <div>
          <p className="font-light text-black text-md text-left mt-8">
            Our company offers the best and most reliable laptops, desktops, IT
            hardware/software,mdart home services, IP phones services and
            firewalls available. Our products are tailored to meet your specific
            needs, ensuring that your business runs smoothly and efficiently.
          </p>
          <p className="font-light text-black text-md text-left mt-8">
            Also, we are always on the cutting edge of technology, and our
            expert customer service team is ready to help with any issue you may
            have. Whether you're a large business or small home office,
            RemotewebNET has the products and services to meet your needs.
          </p>
        </div>
      </div>
      {/* Image */}
      <div className="relative w-full md:pl-10 pl-0 md:mt-0 mt-16">
        <img src={Image} alt="Products" className="w-full h-full" />
        <div className="flex justify-center">
          <Link
            style={{}}
            className="text-white text-center border bg-pink-600 border-pink-600
                          hover:bg-transparent hover:text-pink-600 rounded-sm py-3 px-8 font-medium -mt-6"
            to={"/products"}
          >
            Laptops and Desktops
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Products;
